export default __webpack_public_path__ + "static/media/internInsight.4ac75fe6.jpg";